import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import BaseError from '../../../utils/base-error';
import { PortfolioEventPageState } from './state';
import { PortfolioEventPageActions } from './actions';
import { createPortfolioEventFromGetPortfolioEventByUidApiResponse } from '../utils';

const initialState: PortfolioEventPageState = {
    loaded: false,
    errors: [],
};

export const portfolioEventPageSlice = createSlice({
    name: 'portfolioEventPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            PortfolioEventPageActions.getPortfolioEventByUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const result = createPortfolioEventFromGetPortfolioEventByUidApiResponse(
                            response.data,
                        );

                        state.portfolioEvent = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
